import { Component, OnInit, OnDestroy } from '@angular/core';
import { ObservablesService } from '../observables.service'
import { trigger, state, style, transition, animate} from '@angular/animations';
@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)',
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)',
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('backDrop', [
      state('in', style({
        display: 'block',
      })),
      state('out', style({
        display: 'none',
      }))
    ]),
  ]
})
export class AdminLayoutComponent implements OnInit {
  menuState:string = 'out';
  menuObserver:any;
  constructor(private observables:ObservablesService) {
    this.menuObserver = this.observables.menuStatus.subscribe((data:any)=>{
       this.menuState = data.menuState
    });
  }

  ngOnDestroy(){
    this.menuObserver.unsubscribe()
  }

  ngOnInit() {
  }

  closeMenu(){
    this.observables.setMenuStatus({menuState:'out'})
  }

  public partySelected(partyData: any) {
    // console.log("emited",partyData)
    // this.partyData=partyData;
    this.observables.getSelectedPartyData(partyData)
  }

  public dateRangeChanged(dateRange:any){
    // console.log("selected date rangess=",dateRange)
    this.observables.getSelectedDateRangeData(dateRange)
  }
  public headerDataChanged(data:any){
    // console.log("selected data=",data)
    this.observables.setHeaderData.next(data)
  }


}
